var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Box as MuiBox } from '@mui/material';
import Avatar from '../../../Avatar';
import Text from '../../../Text';
var StyledMuiBox = styled(MuiBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  grid-column-gap: 12px;\n  padding: 0 8px;\n  margin-bottom: 8px;\n"], ["\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  grid-column-gap: 12px;\n  padding: 0 8px;\n  margin-bottom: 8px;\n"])));
var CapitalizedSpan = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-transform: capitalize;\n"], ["\n  text-transform: capitalize;\n"])));
export default function UserDetail(_a) {
    var user = _a.user;
    var firstName = user.firstName, lastName = user.lastName;
    var displayName = '';
    if (firstName)
        displayName += firstName;
    if (lastName)
        displayName += " ".concat(lastName);
    var disableClick = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    return (_jsxs(StyledMuiBox, __assign({ onClick: disableClick }, { children: [_jsx(Avatar, { firstName: firstName, lastName: lastName, variant: "small" }), _jsxs(MuiBox, __assign({ sx: { display: 'grid' } }, { children: [displayName && (_jsx(Text, __assign({ variant: "tableHeaderOLD" }, { children: _jsx(CapitalizedSpan, { children: displayName.trim() }) }))), user.email && (_jsx(Text, __assign({ ellipsis: true, variant: displayName ? 'body3' : 'tableHeaderOLD', color: displayName ? 'neutral60' : 'neutral100' }, { children: user.email })))] }))] })));
}
var templateObject_1, templateObject_2;
